import { trigger, transition, style, animate } from '@angular/animations';

export function leaveAnimation() {
  return trigger('leaveAnimation', [
    transition(':leave', [
      animate('500ms', style({ transform: 'translateX(100%)', opacity: 0 }))
    ])
  ])
}
